import apiFetch from './apiFetch';

const STATIC_BASE = '';

export const ruptureUrl = id =>
  `${STATIC_BASE}/rupture-json/${id}_rupture.geojson`;

export const contourUrl = id =>
  `${STATIC_BASE}/arrivaltime-json/${id}_Tarr_Contour10_Dis.geojson`;

// TIF files must be in EPSG:4326 (WGS84).
// UTM Zone 47N files will NOT render correctly in Leaflet.
// Re-run reproject_all_wgs84.py before uploading new TIF files.
export const waveheightUrl = id =>
  `${STATIC_BASE}/waveheight-tif/${id}_R1215m_Zmax_B5km.tif`;

export const mapJpgUrl = id => `${STATIC_BASE}/map-jpg/${id}_Map.jpg`;

async function fetchJSON(url) {
  const res = await apiFetch(url);
  if (!res.ok) throw new Error(`HTTP ${res.status}: ${url}`);
  return res.json();
}

/**
 * Fetches all rupture GeoJSONs for a given magnitude, merges them into one
 * FeatureCollection, and tags each feature with its scenarioId property.
 */
export async function loadRupturesByMagnitude(magnitude) {
  const indexRes = await apiFetch('/assets/scenarios_index.json');
  const index = await indexRes.json();
  const ids = index[magnitude.toFixed(1)] || [];
  const geojsons = await Promise.all(ids.map(id => fetchJSON(ruptureUrl(id))));
  return {
    type: 'FeatureCollection',
    features: geojsons.flatMap((g, i) =>
      g.features.map(f => ({
        ...f,
        properties: { ...f.properties, scenarioId: ids[i] },
      }))
    ),
  };
}
